// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__GipzR","requiredAsterisk":"Info_requiredAsterisk__2uL16"};